import script from "./EnterSmsCodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterSmsCodeView.vue?vue&type=script&setup=true&lang=js"

import "./EnterSmsCodeView.vue?vue&type=style&index=0&id=926a2bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-926a2bf8"]])

export default __exports__